<div class="d-flex-row-jc-between font32 bold700 color-dark">
  <app-logo class="mr32"></app-logo> <span class="title">WebCScalp</span>
</div>

<div class="font32 mt16 color-dark mb56 text-center">{{ 'start.description' | translate }}</div>

<svg class="loading-spinner" viewBox="25 25 50 50">
    <circle class="path"
    cx="50" cy="50"
    r="20"
    fill="none"
    stroke-width="2"
    stroke-miterlimit="10"/>
</svg>

